import { Logger as s, ConfigService as E } from "@nextgen-web-framework/core";
import { SocialPlateforms as r, useTranslation as m, UserType as h } from "@nextgen-web-framework/all";
import { WebEvents as o, sharebarApi as g } from "@commerce-webcomponents/sdk";
import { l as u } from "../../logObject-9b027f24.mjs";
import { ShareEventsEnum as w } from "./types/types.js";
const d = s.getInstance(u("sharebarHelper.ts")), O = (e, a) => {
  const { productData: t } = e != null && e.data ? f(e == null ? void 0 : e.data) ? JSON.parse(e == null ? void 0 : e.data) : { productData: {} } : { productData: {} };
  o.publishEvent({
    event: w.SHARE,
    sync: !1,
    payload: {
      product_brand: [(t == null ? void 0 : t.brandName) ?? ""],
      share_channel: [a && y[a]],
      product_id: [(t == null ? void 0 : t.productId) ?? ""],
      product_name: [(t == null ? void 0 : t.productName) ?? ""],
      product_pointValue: [(t == null ? void 0 : t.pointValue) ?? ""],
      product_unitPrice: [(t == null ? void 0 : t.productPrice) ?? ""]
    }
  });
}, I = async ({
  linkProps: e,
  sharingChannel: a,
  regType: t
}) => {
  const n = {
    fullUrl: e == null ? void 0 : e.fullUrl,
    title: e == null ? void 0 : e.title,
    category: e == null ? void 0 : e.category,
    data: e == null ? void 0 : e.data,
    sharingChannel: a,
    registrationAccountType: (e == null ? void 0 : e.registrationAccountType) ?? t
  };
  try {
    return await g.createSharebar({
      payload: n
    });
  } catch (c) {
    return d.error(c), Promise.reject(c);
  }
}, L = (e, a, t) => {
  const n = "sharelinks";
  if (a)
    return e ? `${a}/${e}` : a;
  const b = `${E.getConfigs().NEXT_PUBLIC_WEB_BASE_PATH}/${t || n}`;
  return e ? `${b}/${e}` : b;
}, f = (e) => {
  try {
    return JSON.parse(e), !0;
  } catch {
    return !1;
  }
}, N = (e, a) => [
  {
    type: r.LINE,
    enabled: !!e.lineUrl,
    titleKey: "web.sharing.channel.line.title"
  },
  {
    type: r.WHATSAPP,
    enabled: !!e.whatsappUrl,
    titleKey: "web.sharing.channel.whatsapp.title"
  },
  {
    type: r.FACEBOOK,
    enabled: !!e.fbUrl,
    titleKey: "web.sharing.channel.facebook.title"
  },
  {
    type: r.EMAIL,
    enabled: e.emailEnable,
    titleKey: "web.sharing.channel.email.title"
  },
  {
    type: r.LINK,
    enabled: e.copyLinkEnable,
    titleKey: "web.sharing.channel.copylink.title"
  },
  {
    type: r.MORE,
    enabled: e.moreOptionsEnable && a,
    titleKey: "web.sharing.channel.more.title"
  }
], y = {
  [r.EMAIL]: "email",
  [r.FACEBOOK]: "facebook",
  [r.LINE]: "line",
  [r.LINK]: "link",
  [r.WHATSAPP]: "whatsapp",
  [r.MORE]: "more",
  [r.TWITTER]: "twitter",
  [r.INSTAGRAM]: "instagram",
  [r.TIKTOK]: "tiktok",
  [r.LINK_COPIED]: "copied"
}, U = (e) => {
  const a = m();
  return {
    [h.ABO]: {
      shareTitle: a("web.sharebarDrawer.abo"),
      shareDescription: a("web.sharebarDrawer.abo.desc")
    },
    [h.MEMBER]: {
      shareTitle: a("web.sharebarDrawer.member"),
      shareDescription: a("web.sharebarDrawer.member.desc")
    },
    [h.REGISTERED]: {
      shareTitle: a("web.sharebarDrawer.customer"),
      shareDescription: a("web.sharebarDrawer.customer.desc")
    }
  }[e];
};
export {
  f as IsJsonSafe,
  I as createSharecode,
  L as getSharePath,
  N as getSocialLinksConfig,
  O as publishShareEvent,
  y as shareEventChannel,
  U as useShareUserConfig
};
//# sourceMappingURL=sharebarHelpers.js.map
